import { SET_SITE, UPDATE_SITE, State, REMOVE_SITE } from "./types";

export function siteReducer(state: State = { site: '', updateSite: false }, action) {

    switch (action.type) {
        case SET_SITE: {
            return {
                ...state,
                site: action.payload
            }
        }
        case UPDATE_SITE: {
            return {
                ...state,
                updateSites: action.payload
            }
        }
        case REMOVE_SITE:
            const { [action.payload]: _, ...remainingSites } = state.site;
            return {
                ...state,
                site: remainingSites
            };
        default:
            return state;
    }

}
